import React, { useEffect, useState } from "react";
import { ArrowsClockwise } from "@phosphor-icons/react";

function ago(ts) {
  if (!ts) return "Refresh";
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 5) return "Updated just now";
  if (s < 60) return `Updated ${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `Updated ${m}m ago`;
  return `Updated ${Math.floor(m / 60)}h ago`;
}

// Lightweight fixed-position refresh indicator. Shows a spinner while fetching
// and "Updated just now" afterwards; tap to manually refetch.
export function RefreshBar({ refreshing, lastUpdated, onRefresh }) {
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 15000);
    return () => clearInterval(t);
  }, []);
  return (
    <button
      onClick={onRefresh}
      disabled={refreshing}
      data-testid="refresh-bar"
      aria-label="Refresh latest data"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full border border-border bg-card/90 backdrop-blur px-4 h-10 text-xs font-semibold text-muted-foreground shadow-lg hover:text-foreground transition-colors"
    >
      <ArrowsClockwise size={15} className={`text-primary ${refreshing ? "animate-spin" : ""}`} />
      {refreshing ? "Refreshing…" : ago(lastUpdated)}
    </button>
  );
}
